import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface SecurityProfileLayoutProps {
  leftContent: ReactNode;
  rightContent: ReactNode;
  className?: string;
}

const StyledContainer = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: var(--default-padding);
  }
`;

const StyledGrid = styled.div`
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  display: flex;

  @media (max-width: 768px) {
    display: block;
  }
`;

const StyledLeftColumn = styled.div`
  padding: var(--large-padding) var(--semi-big-padding) 0
    var(--semi-big-padding);
  width: 317px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: auto;
    padding-right: 0;
    margin-bottom: var(--big-padding);
  }
`;

const StyledRightColumn = styled.div`
  padding: var(--large-padding);
`;

const StyledRightColumnContainer = styled.div`
  background: var(--beige-main);
  border-top-right-radius: var(--medium-border-radius);
  border-bottom-right-radius: var(--medium-border-radius);
  flex: 1;

  @media (max-width: 768px) {
    flex: none;
    border-top-right-radius: 0;
    border-bottom-left-radius: var(--medium-border-radius);
  }
`;

export const SecurityProfileLayout: React.FC<SecurityProfileLayoutProps> = ({
  leftContent,
  rightContent,
  className,
}) => {
  return (
    <StyledContainer className={className}>
      <StyledGrid>
        <StyledLeftColumn className="flex flex-column h-full">
          {leftContent}
        </StyledLeftColumn>
        <StyledRightColumnContainer>
          <StyledRightColumn className="flex flex-column h-full">
            {rightContent}
          </StyledRightColumn>
        </StyledRightColumnContainer>
      </StyledGrid>
    </StyledContainer>
  );
};

export const SecurityProfileIconContainer = styled.div`
  margin-bottom: var(--default-padding);

  img {
    width: 40px;
    height: 32px;
  }
`;

export const SecurityProfileTitle = styled.h1`
  font-size: var(--heading-medium-font-size);
  line-height: var(--heading-medium-line-height);
  font-weight: 700;
  color: var(--black-main);
  margin-bottom: var(--default-padding);
`;

export const SecurityProfileDescription = styled.p`
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  margin-bottom: var(--small-padding);

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SecurityProfileMetadata = styled.p`
  font-size: var(--xxsmall-font-size);
  line-height: 1.4;
  color: var(--black-main);
  margin-top: auto;
`;

export const SecurityProfileContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    padding: var(--default-padding);
  }
`;
